<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <OfficeTypeListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import OfficeTypeListing from "@/views/pages/admin/officeType/officeTypeListing";

export default {
    page: {
        title: i18n.t("module.officeType"),
    },
    components: { Layout, PageHeader, OfficeTypeListing },
    data() {
        return {
            title: i18n.t("module.officeType"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: '/workplaces',
                },
                {
                    text: i18n.t("module.officeType"),
                    active: true,
                },
            ],
        };
    },
}
</script>